import { Dialog } from "../../components-v2/Dialog";
import { Box, VBox } from "../../components-v2/Box";
import { MTextInput } from "../../components-v2/TextInput";
import { observer } from "mobx-react";
import { Alert } from "../../components-v2/Alert";
import { Markdown } from "../../text/Markdown";
import { useState } from "react";
import { useMessageStore, useTranslation } from "../../stores/RootStoreContext";
import { StringFieldModel } from "../../common/commonForms";

import { InfoButton } from "../../components-v2/InfoButton";
import { DCEvent, EventDispatcher } from "../../events/eventsDomain";
import { isArray } from "lodash";

export const EditProjectNameDialog = observer(function ({
  name,
  onSave,
  onClose,
  isDuplicate,
}: {
  name: StringFieldModel;
  onSave: ((name: string) => void) | ((name: string) => DCEvent[]) | DCEvent[];
  onClose: () => void;
  isDuplicate: boolean;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const messageStore = useMessageStore();

  const onSubmit = (dispatch: EventDispatcher): void => {
    if (name.validate() && !isArray(onSave)) {
      setIsLoading(true);
      try {
        const result = onSave(name.validatedValue);
        if (isArray(result)) {
          dispatch(result);
        }
      } catch (error) {
        messageStore.showGeneralError();
        setIsLoading(false);
      }
    }
  };
  return (
    <Dialog
      title={t("dbot.new-project-name.title")}
      onCancel={onClose}
      onSubmit={isArray(onSave) ? onSave : onSubmit}
      submitLabel={t("save")}
      isSubmitting={isLoading}
    >
      <VBox>
        <Box>
          {t("dbot.new-project-name.label")}
          <InfoButton infoText={t("dbot.new-project-name.info")} />
        </Box>
        <MTextInput model={name} />
        {isDuplicate && (
          <Alert
            type={"info"}
            message={<Markdown value={t("dbot.duplicate.noAttachmentsIncluded")} />}
          />
        )}
      </VBox>
    </Dialog>
  );
});
